

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.onFormReady();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('.cart-count-bubble');
    }

    onFormReady(){
      if(!this.form) return;
      const id = this.form.getAttribute('id') || "";
      const disabledStyle = document.querySelector(`#${id}-disabled-style`);
      if (disabledStyle) {
        disabledStyle.remove();
      }
    }

    static resetReferrals(data){
      const attributes = [
        'attributes[friendbuyReferralCode]',
        'attributes[Referral Code No Discount]',
        'attributes[Promo Link]',
        'attributes[Promo Link No Discount]'
      ]
      attributes.forEach(attribute => {
        data.append(attribute, '')
      })
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const proofGrade = parseInt(formData.get(window.proofgrade));
      if (!isNaN(proofGrade) && proofGrade !== null) {
        const oldQuantity = parseInt(formData.get('quantity'));
        const newQuantity = oldQuantity * proofGrade;
        formData.set('quantity', newQuantity);
      };

      formData.append('sections_url', window.location.pathname);

      ProductForm.resetReferrals(formData)
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async(response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          this.cartNotification.querySelectorAll("span")?.forEach(count => {
            if (!count) return;
            parseInt(count.innerText) === 0 && this.cartNotification.classList.remove('hide')
            const itemCountToAdd = parseInt(count.innerText) + (response?.items?.length || 1)
            count.innerText = count.innerText.replace(parseInt(count.innerText), itemCountToAdd)
          })

          if (this.hasAttribute("redirect")) {
            if(window.addWarrantyToCart && window.mulberryPDPModal && window.offers && window.offers.length > 0) {
              const predefinedWarranty = this.dataset?.warranty;
              if(predefinedWarranty && predefinedWarranty !== 'popup' && predefinedWarranty !== 'none'){
                // If the predefined warranty is available, select the warranty option
                const currentOffer = window.offers.find(offer => Number(offer.duration_months) === Number(predefinedWarranty));
                window.selectedWarranty = { isSelected: true, offer: currentOffer }
              } else if(predefinedWarranty === 'none'){
                // If there is no warranty predefined, skip the warranty (popup) and redirect to the checkout page
                this.directCheckout();
                return;
              }
              // Store reference to original form for modal callbacks
              window.originalBundleForm = this;
              this.warranty = await window.addWarrantyToCart();
              if (this.warranty?.result != null) {
                this.directCheckout();
                return;
              } else {
                return;
              }
            }
            this.directCheckout();
            return;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.toggleButtonStatus()
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    toggleButtonStatus() {
      const message = this.querySelector('.success-message')
      if (!message) return;

      const submitButton = message.closest('[type="submit"]');
      submitButton.disabled = true;
      message.classList.add('visible');
      setTimeout(() => {
        message.classList.remove('visible')
        submitButton.disabled = false;
      }, 1000)
    }

    directCheckout() {
      const formId = this.form.getAttribute('id');
      const submitButtons = document.querySelectorAll(`button[form="${formId}"]`);
      submitButtons.forEach(button => {
        if(!button) return;
        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
        const loadingOverlay =  button.querySelector('.loading-overlay__spinner');
        if(loadingOverlay) {
          loadingOverlay.classList.add('hidden');
        }
      });

      const formData = new FormData(this.form);

      const entries = Object.fromEntries(formData);

      const searchParams = new URLSearchParams();
      ProductForm.resetReferrals(searchParams)

      const discounts = formData.getAll('discount');

      if(discounts.length > 0){
        searchParams.append('discount', discounts.join(','));
      }

      Object.keys(entries).forEach(key => {
        if (key.includes('attributes')) {
          // Replaces the empty referral attributes with their actual values.
          searchParams.append(key, entries[key]);
        }
      })

      // if(this.warranty.result){
      //   // itemIds.push(`${this.warranty.result.shopify_variant_id}:1`);
      // }

      const searchParamsString = searchParams.toString();
      const separator = searchParamsString ? '?' : ''
      const url = `${window.shopUrl}/checkout/${separator}${searchParamsString}`
      window.location = url;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      errorMessage ? this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage) : this.errorMessageWrapper.setAttribute('hidden', true);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}